var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 14,
    viewBox: "0 0 28 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0369 10.2669C13.5114 9.80022 13.0533 9.38144 12.5816 8.97462C9.41515 6.1628 6.23518 3.33901 3.06869 0.527195C2.2737 -0.178751 1.1688 -0.166787 0.45465 0.527194C-0.097802 1.06563 -0.151696 1.8673 0.319909 2.45359C0.414229 2.57324 0.522021 2.68093 0.643292 2.77665C4.6452 6.33031 8.63364 9.87201 12.6355 13.4257C13.4979 14.1914 14.5085 14.1914 15.3709 13.4257C19.3862 9.86004 23.3881 6.30638 27.4035 2.74076C28.2928 1.95105 28.1716 0.778466 27.1475 0.228067C26.5277 -0.106959 25.7731 -0.0710632 25.1937 0.323788C25.0725 0.407545 24.9781 0.491301 24.8703 0.587023C21.34 3.7219 17.8097 6.84482 14.2929 9.9797C14.2121 10.0515 14.1447 10.1472 14.0369 10.2669Z",
    fill: "#CF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/Chevron-Up.17495c575ed08fae88607f101008ba8f.svg";
export { ForwardRef as ReactComponent };